/**
 * React Query hooks for infrastructure monitoring
 * Provides polling query for PDP/PEP infrastructure status
 */

import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api-client'
import type { InfrastructureStatus } from '@/types/infrastructure'

/**
 * Query keys for infrastructure
 */
export const infrastructureKeys = {
  all: ['infrastructure'] as const,
  status: () => [...infrastructureKeys.all, 'status'] as const,
}

/**
 * Fetch infrastructure status with 15s polling for near-real-time updates
 */
export function useInfrastructureStatus() {
  return useQuery({
    queryKey: infrastructureKeys.status(),
    queryFn: () => get<InfrastructureStatus>('/infrastructure/status'),
    refetchInterval: 15_000,
  })
}
